import { render, staticRenderFns } from "./ideas.vue?vue&type=template&id=6c99d5af&scoped=true"
import script from "./ideas.vue?vue&type=script&lang=js"
export * from "./ideas.vue?vue&type=script&lang=js"
import style0 from "./ideas.vue?vue&type=style&index=0&id=6c99d5af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c99d5af",
  null
  
)

export default component.exports